<life-di-nav></life-di-nav>

<div class="container text-center">
  <div class="row justify-content-center mt-5">
    <div class="col-8">
      <h1 class="lifedi-color">
        Skill Tree
      </h1>
    </div>
  </div>
  <div class="mt-4 mb-3">
    <lifedi-symbol-skill-tree></lifedi-symbol-skill-tree>
  </div>
  <div class="row">
    <div *ngFor="let skilltree of allSkillTree; let i = index;" class="col-12 mt-1 mb-4">
      <h4 class="text-center">{{skilltree.TREE_NAME}}</h4>
      <lifedi-skill-tree [nodes]="skilltree?.NODES" [clusters]="skilltree?.CLUSTER_NODES" [links]="skilltree?.LINKS">
      </lifedi-skill-tree>
    </div>
  </div>
</div>

<lifedi-footer></lifedi-footer>
